import { render } from "./TransporteDonut.vue?vue&type=template&id=71fd500c&scoped=true"
import script from "./TransporteDonut.vue?vue&type=script&lang=js"
export * from "./TransporteDonut.vue?vue&type=script&lang=js"

import "./TransporteDonut.vue?vue&type=style&index=0&id=71fd500c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fd500c"]])

export default __exports__